import React, { useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import AddIcon from "@mui/icons-material/Add";
import HistoryIcon from "@mui/icons-material/History";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import {
  chatPaneClose,
  fetchTokenUsage,
  historyViewClose,
  historyViewOpen,
  startNewChat,
} from "../../store/actions/chatbot";

function fmtTokens(n) {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000)     return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

function ChatPaneHeader() {
  const dispatch         = useDispatch();
  const historyViewActive = useSelector((s) => s.chatbot.historyViewActive);
  const totalInputTokens  = useSelector((s) => s.chatbot.totalInputTokens);
  const totalOutputTokens = useSelector((s) => s.chatbot.totalOutputTokens);

  useEffect(() => {
    dispatch(fetchTokenUsage());
  }, []);

  return (
    <div className="chat-pane-header">
      <span className="chat-pane-header__title">
        <SmartToyIcon className="chat-pane-header__bot-icon" fontSize="small" />
        {historyViewActive ? "Chat History" : "Aye Assistant"}
      </span>

      <div className="chat-pane-header__tokens">
        <Tooltip title="Total input tokens used">
          <span className="chat-pane-header__token-badge chat-pane-header__token-badge--in">
            ↑ {fmtTokens(totalInputTokens)}
          </span>
        </Tooltip>
        <Tooltip title="Total output tokens used">
          <span className="chat-pane-header__token-badge chat-pane-header__token-badge--out">
            ↓ {fmtTokens(totalOutputTokens)}
          </span>
        </Tooltip>
      </div>

      {historyViewActive ? (
        <Tooltip title="Back to chat">
          <IconButton size="small" onClick={() => dispatch(historyViewClose())}>
            <ArrowBackIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <>
          <Tooltip title="New chat">
            <IconButton size="small" onClick={() => dispatch(startNewChat())}>
              <AddIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Chat history">
            <IconButton size="small" onClick={() => dispatch(historyViewOpen())}>
              <HistoryIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      )}

      <Tooltip title="Close">
        <IconButton size="small" onClick={() => dispatch(chatPaneClose())}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default ChatPaneHeader;
